import React from 'react';

import { Button } from 'react-bootstrap';

type Props = {
  disabled?: boolean;
  onResetClick?(): void;
  onSaveClick(event: any): void;
};

const ActivitySectionButtons = ({
  onSaveClick,
  onResetClick,
  disabled,
}: Props) => (
  <div className='activity-section-buttons'>
    <Button
      type='submit'
      className='submit'
      bsStyle='primary'
      disabled={disabled}
      onClick={onSaveClick}
    >
      Save
    </Button>
    {onResetClick && (
      <Button disabled={disabled} onClick={onResetClick}>
        Reset
      </Button>
    )}
  </div>
);

export default ActivitySectionButtons;
